/*
  Vortex team store: each product's button ticks it in the team order form ("What do you need?"),
  so the club gets one conversation about everything. The bottom button adds a whole team store
  and takes them to the form.
*/
(() => {
  const root = document.querySelector('[data-team-store]');
  if (!root) return;

  const chip = (need) => Array.from(document.querySelectorAll('[data-need]')).find((c) => c.dataset.need.toLowerCase() === need.toLowerCase());

  const sync = () => {
    root.querySelectorAll('[data-store-need]').forEach((b) => {
      const c = chip(b.dataset.storeNeed);
      const on = !!(c && c.checked);
      b.setAttribute('aria-pressed', String(on));
      b.classList.toggle('is-on', on);
      const label = b.querySelector('[data-store-label]');
      if (!label.dataset.off) label.dataset.off = label.textContent;
      label.textContent = on ? 'Added to your order ✓' : label.dataset.off;
    });
  };

  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-store-need]');
    if (!b) return;
    const c = chip(b.dataset.storeNeed);
    if (!c) {
      // no order form on this page: take them to it
      window.location.href = '/pages/team-orders#team-kit-form';
      return;
    }
    c.checked = b.hasAttribute('data-store-go') ? true : !c.checked;
    c.dispatchEvent(new Event('change', { bubbles: true })); // the form saves its draft on change
    sync();
    if (b.hasAttribute('data-store-go')) {
      const form = document.getElementById('team-kit-form');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  document.addEventListener('change', (e) => { if (e.target.matches && e.target.matches('[data-need]')) sync(); });
  sync();
})();
